import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './LoginPage.css';
import { useAuth } from '../context/AuthContext.js'; // 1. Import the useAuth hook
import logoDark from '../assests/logo-dark.png'; 

function LoginPage() {
  const [isLoginView, setIsLoginView] = useState(true);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login, signup } = useAuth(); // 2. Get the REAL functions from the context

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const name = e.target.name.value;
    const email = e.target.email.value;
    const password = e.target.password.value;

    if (password.length < 6) {
        setError("Password should be at least 6 characters long.");
        setLoading(false);
        return;
    }

    try {
      // 3. Call the real Firebase signup function
      await signup(email, password, name);
      
      // 4. This is the logic you requested:
      alert('Signup successful! Logging you in...');
      
      // Now, log the user in
      const role = await login(email, password);
      if (role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/dashboard');
      }

    } catch (err) {
      if (err.code === 'auth/email-already-in-use') {
        setError('This email is already in use. Please log in.');
      } else {
        setError('Failed to create an account. Please try again.');
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const email = e.target.email.value;
    const password = e.target.password.value;

    try {
      // 5. Call the real Firebase login function
      const role = await login(email, password); 

      if (role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/dashboard');
      }
      
    } catch (err) {
      setError('Invalid email or password.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="image-panel">
          <img src="https://images.unsplash.com/photo-1565557623262-b51c2513a641?auto=format&fit=crop&w=800&q=80" alt="Food" />
        </div>
        <div className="form-panel">
          <Link to="/" className="close-button">&times;</Link>
          <div className="logo-container logo-margin-bottom">
            <img src={logoDark} alt="Degchi Logo" className="logo-image" />
            {/* <h1 className="logo-text">degchi</h1> */}
          </div>

          {error && <p className="error-message">{error}</p>}

          {isLoginView ? (
            <div>
              <h2 className="form-title">Welcome Back</h2>
              <p className="form-subtitle">Please enter your details to login.</p>
              <form onSubmit={handleLogin} className="login-form">
                <div>
                  <label htmlFor="login-email">Email</label>
                  <input id="login-email" name="email" type="email" placeholder="you@example.com" required />
                </div>
                <div>
                  <label htmlFor="login-password">Password</label>
                  <input id="login-password" name="password" type="password" placeholder="••••••••" required />
                </div>
                <button type="submit" disabled={loading}>
                  {loading ? 'Logging in...' : 'Login'}
                </button>
              </form>
              <p className="toggle-text">
                Don't have an account?
                <button onClick={() => { setIsLoginView(false); setError(''); }} className="toggle-button">Sign Up</button>
              </p>
            </div>
          ) : (
            <div>
              <h2 className="form-title">Create an Account</h2>
              <p className="form-subtitle">Start your journey with delicious homemade food.</p>
              <form onSubmit={handleSignup} className="login-form">
                <div>
                  <label htmlFor="signup-name">Full Name</label>
                  <input id="signup-name" name="name" type="text" placeholder="Aisha Khan" required />
                </div>
                <div>
                  <label htmlFor="signup-email">Email</label>
                  <input id="signup-email" name="email" type="email" placeholder="you@example.com" required />
                </div>
                <div>
                  <label htmlFor="signup-password">Password</label>
                  <input id="signup-password" name="password" type="password" placeholder="••••••••" required />
                </div>
                <button type="submit" className="signup-button" disabled={loading}>
                  {loading ? 'Creating...' : 'Create Account'}
                </button>
              </form>
              <p className="toggle-text">
                Already have an account?
                <button onClick={() => { setIsLoginView(true); setError(''); }} className="toggle-button">Login</button>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default LoginPage;

